import { Link as RooLink } from 'roo-ui/components';
import { TRAVEL_REQUIREMENTS_URL } from 'config/constants';
import * as tracking from 'lib/gaTracking/bookingDetailsPageEvents';
import { ImportantInfoAlert } from 'components/Alerts';
import { WideLink } from 'components/Typography';

// TODO: remove and delete TravelDocumentationReminder component completely when covid-19 vaccine available!
export const TravelDocumentationReminder = () => (
  <ImportantInfoAlert>
    <ImportantInfoAlert.Heading>Before you travel, please check the latest government requirements</ImportantInfoAlert.Heading>
    <ImportantInfoAlert.Body>
      Some Australian states and territories have introduced new measures, including additional health and safety protocols, in response to
      Coronavirus.
    </ImportantInfoAlert.Body>
    <WideLink
      variant=""
      mt={2}
      color="emperor"
      underline={true}
      as={RooLink}
      data-testid="view-travel-requirements-link"
      href={TRAVEL_REQUIREMENTS_URL}
      onClick={tracking.viewTravelRequirementsLinkSelected}
      target="_blank"
    >
      View travel requirements
    </WideLink>
  </ImportantInfoAlert>
);
